module.exports = __webpack_public_path__ + "img/smart-suggestions.9c25bba9.png";